import Axios from 'axios'
const SEARCH_API_HOST = process.env.VUE_APP_SEARCH_API_HOST
const SEARCH_API_VERSION = process.env.VUE_APP_SEARCH_API_VERSION

const KEYWORD_ON_SUBMIT = 'KEYWORD_ON_SUBMIT'
const KEYWORD_ON_SUBMIT_MORE = 'KEYWORD_ON_SUBMIT_MORE'

const UPDATE_KEYWORD = 'UPDATE_KEYWORD'
const UPDATE_CURRENT = 'UPDATE_CURRENT'
const UPDATE_STATUS = 'UPDATE_STATUS'
const UPDATE_INPUT_POSITION = 'UPDATE_INPUT_POSITION'

const SEARCH_REQUEST = 'SEARCH_REQUEST'
const SEARCH_REQUEST_ERROR = 'SEARCH_REQUEST_ERROR'
const SEARCH_REQUEST_SUCCESS = 'SEARCH_REQUEST_SUCCESS'
const SEARCH_REQUEST_MORE_SUCCESS = 'SEARCH_REQUEST_MORE_SUCCESS'
const SEARCH_RESET = 'SEARCH_RESET'

const state = {
  status: '',
  scope: 'read',
  type: 'article',
  keyword: '',
  results: [],
  page: {
    current: 0,
    total: 0
  },
  total: 0,
  numPerPage: 20, // request num per page
  current: 1,
  inputPosition: 'relative'
}
const getters = {
  getSearchScope: state => state.scope,
  getSearchType: state => state.type,
  getSearchStatus: state => state.status,
  getSearchResults: state => state.results,
  getSearchPage: state => state.page,
  getSearchedKeyword: state => state.keyword,
  getSearchCurrentPage: state => state.current,
  getSearchInputPosition: state => state.inputPosition
}
const mutations = {
  [UPDATE_INPUT_POSITION]: (state, position) => {
    state.inputPosition = position
  },
  [UPDATE_KEYWORD]: (state, params) => {
    state.keyword = params.keyword
    state.scope = params.scope || state.scope
    state.type = params.type || state.type
  },
  [UPDATE_CURRENT]: (state, current) => {
    state.current = current
  },
  [UPDATE_STATUS]: (state, status) => {
    state.status = status
  },
  [SEARCH_REQUEST]: (state) => {
    state.status = 'PENDING'
  },
  [SEARCH_REQUEST_SUCCESS]: (state, data) => {
    state.status = 'SUCCESS'
    state.results = data
    if (state.type !== 'all') {
      const matchedObj = data.find(searchObj => searchObj[state.type])
      state.total = matchedObj.total
      state.page = {
        current: Number.parseInt(matchedObj.page.current),
        total: Number.parseInt(matchedObj.page.total)
      }
    } else {
      state.total = 0
      state.page = {
        current: 0,
        total: 0
      }
    }
  },
  [SEARCH_REQUEST_MORE_SUCCESS]: (state, data) => {
    if (state.type !== 'all') {
      const formerResultObj = state.results.find(formerObj => formerObj[state.type])
      const matchedObj = data.find(searchObj => searchObj[state.type])
      formerResultObj[state.type] = formerResultObj[state.type].concat(matchedObj[state.type])
      state.page.current = Number.parseInt(matchedObj.page.current)
      state.page.total = Number.parseInt(matchedObj.page.total)
      state.results.page = state.page
      state.results.total = Number.parseInt(matchedObj.total)
      state.total = matchedObj.total
    } else {
      state.results = data
      state.total = 0
      state.page = {
        current: 0,
        total: 0
      }
    }
    state.status = 'SUCCESS'
  },
  [SEARCH_REQUEST_ERROR]: state => {
    state.status = 'ERROR'
  },
  [SEARCH_RESET]: state => {
    state.keyword = ''
    state.results = []
    state.total = 0
    state.page = { current: 0, total: 0 }
  }
}
const actions = {
  [KEYWORD_ON_SUBMIT]: ({ commit, dispatch, state }, params) => {
    commit(SEARCH_RESET)
    commit(SEARCH_REQUEST)
    let queryAry = [
      params.size ? `size=${params.size}` : `size=${state.numPerPage}`,
      params.page ? `page=${params.page}` : `page=${state.current}`
    ]
    if (params.lang) {
      queryAry.push(`lang=${params.lang}`)
    }
    const queryStr = queryAry.join('&')
    const requestBaseURL = `${SEARCH_API_HOST}/${SEARCH_API_VERSION}`

    const requstURL = `${requestBaseURL}/search/${params.scope}/${params.type}/${params.keyword}?${queryStr}`
    Axios.request({
      method: 'GET',
      headers: {},
      url: requstURL
    })
      .then(res => {
        commit(UPDATE_KEYWORD, params)
        commit(UPDATE_CURRENT, params.page.current || 1)
        commit(SEARCH_REQUEST_SUCCESS, res.data.data) // after update keyword
      })
      .catch(err => {
        commit(UPDATE_KEYWORD, params)
        commit(SEARCH_REQUEST_ERROR, err)
        // commit(SEARCH_RESET)
      })
  },
  [KEYWORD_ON_SUBMIT_MORE]: ({ commit, dispatch, state }, params) => {
    commit(SEARCH_REQUEST)
    let queryAry = [
      params.size ? `size=${params.size}` : `size=${state.numPerPage}`,
      params.page ? `page=${params.page}` : `page=${state.current}`
    ]
    if (params.lang) {
      queryAry.push(`lang=${params.lang}`)
    }
    const queryStr = queryAry.join('&')
    const requestBaseURL = `${SEARCH_API_HOST}/${SEARCH_API_VERSION}`

    const requstURL = `${requestBaseURL}/search/${state.scope}/${state.type}/${state.keyword}?${queryStr}`
    Axios.request({
      method: 'GET',
      headers: {},
      url: requstURL
    })
      .then(res => {
        commit(SEARCH_REQUEST_MORE_SUCCESS, res.data.data)
        commit(UPDATE_CURRENT, params.page.current || state.current + 1)
      })
      .catch(err => {
        commit(SEARCH_REQUEST_ERROR, err)
        // commit(SEARCH_RESET)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
